import { render, staticRenderFns } from "./CommendToShoppers.vue?vue&type=template&id=604e4c5e&scoped=true&"
import script from "./CommendToShoppers.vue?vue&type=script&lang=js&"
export * from "./CommendToShoppers.vue?vue&type=script&lang=js&"
import style0 from "./CommendToShoppers.vue?vue&type=style&index=0&id=604e4c5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e4c5e",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput});
